import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [modo, setModo] = useState('login'); // login | trocar
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [sucesso, setSucesso] = useState('');
  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setErro('');
    try {
      const formData = new URLSearchParams();
      formData.append('username', email);
      formData.append('password', senha);
      const res = await api.post('/auth/login', formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });
      localStorage.setItem('token', res.data.access_token);
      localStorage.setItem('usuario', JSON.stringify({ nome: res.data.nome, perfil: res.data.perfil }));
      navigate('/dashboard');
    } catch {
      setErro('Email ou senha incorretos');
    }
  }

  async function handleTrocarSenha(e) {
    e.preventDefault();
    setErro('');
    setSucesso('');
    if (novaSenha !== confirmarSenha) { setErro('As senhas não coincidem'); return; }
    if (novaSenha.length < 6) { setErro('A nova senha deve ter pelo menos 6 caracteres'); return; }
    try {
      await api.post('/auth/trocar-senha', {
        email,
        senha_atual: senhaAtual,
        nova_senha: novaSenha,
      });
      setSucesso('Senha alterada com sucesso!');
      setSenhaAtual(''); setNovaSenha(''); setConfirmarSenha('');
      setTimeout(() => { setModo('login'); setSucesso(''); }, 2000);
    } catch {
      setErro('Email ou senha atual incorretos');
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src="/logo.png" alt="Vera Soluções" style={styles.logo} />
        <h2 style={styles.titulo}>{modo === 'login' ? 'Acesso ao Sistema' : 'Trocar Senha'}</h2>

        {modo === 'login' ? (
          <form onSubmit={handleLogin}>
            <div style={styles.campo}>
              <label style={styles.label}>Email</label>
              <input style={styles.input} type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Senha</label>
              <input style={styles.input} type="password" value={senha} onChange={e => setSenha(e.target.value)} required />
            </div>
            {erro && <p style={styles.erro}>{erro}</p>}
            <button style={styles.botao} type="submit">Entrar</button>
            <button type="button" style={styles.linkTrocar} onClick={() => { setModo('trocar'); setErro(''); }}>
              Trocar senha
            </button>
          </form>
        ) : (
          <form onSubmit={handleTrocarSenha}>
            <div style={styles.campo}>
              <label style={styles.label}>Email</label>
              <input style={styles.input} type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Senha atual</label>
              <input style={styles.input} type="password" value={senhaAtual} onChange={e => setSenhaAtual(e.target.value)} required />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Nova senha</label>
              <input style={styles.input} type="password" value={novaSenha} onChange={e => setNovaSenha(e.target.value)} required />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Confirmar nova senha</label>
              <input style={styles.input} type="password" value={confirmarSenha} onChange={e => setConfirmarSenha(e.target.value)} required />
            </div>
            {erro && <p style={styles.erro}>{erro}</p>}
            {sucesso && <p style={styles.sucesso}>{sucesso}</p>}
            <button style={styles.botao} type="submit">Alterar senha</button>
            <button type="button" style={styles.linkTrocar} onClick={() => { setModo('login'); setErro(''); setSucesso(''); }}>
              Voltar ao login
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0f2f5' },
  card: { backgroundColor: '#fff', padding: '2.5rem', borderRadius: '12px', width: '100%', maxWidth: '380px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
  logo: { width: '120px', display: 'block', margin: '0 auto 1.5rem', backgroundColor: '#1a1a2e', borderRadius: '8px', padding: '8px' },
  titulo: { fontSize: '18px', color: '#1a1a2e', textAlign: 'center', marginBottom: '1.5rem', fontWeight: '500' },
  campo: { marginBottom: '1rem' },
  label: { fontSize: '12px', color: '#555', marginBottom: '4px', display: 'block' },
  input: { width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' },
  botao: { width: '100%', padding: '11px', backgroundColor: '#1a1a2e', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '14px', cursor: 'pointer', marginTop: '0.5rem' },
  erro: { color: '#e53935', fontSize: '13px', marginBottom: '0.5rem', backgroundColor: '#ffebee', padding: '8px 12px', borderRadius: '6px' },
  sucesso: { color: '#388e3c', fontSize: '13px', marginBottom: '0.5rem', backgroundColor: '#e8f5e9', padding: '8px 12px', borderRadius: '6px' },
  linkTrocar: { width: '100%', padding: '8px', backgroundColor: 'transparent', color: '#888', border: 'none', fontSize: '13px', cursor: 'pointer', marginTop: '8px', textDecoration: 'underline' },
};